/**
 * Visszaadja egy megadott dátum vagy dátum-szerű érték másodpercét.
 * @param {string | number | Date} date - A megadott paraméter.
 * @returns {number} A másodperc.
 */
module.exports.getSeconds = function getSeconds (date) {
  return (new Date(date)).getSeconds()
}
